// 管理员状态管理模块
const state = {
  dashboardData: null,
  activities: [],
  classes: [],
  schedules: []
};

const mutations = {
  SET_DASHBOARD_DATA(state, data) {
    state.dashboardData = data;
  },
  SET_ACTIVITIES(state, activities) {
    state.activities = activities;
  },
  SET_CLASSES(state, classes) {
    state.classes = classes;
  },
  SET_SCHEDULES(state, schedules) {
    state.schedules = schedules;
  }
};

const actions = {
  fetchDashboardData({ commit }) {
    // 这里应该是实际的API请求
    // 模拟异步请求
    return new Promise(resolve => {
      setTimeout(() => {
        const data = {
          studentCount: 256,
          classCount: 15,
          teacherCount: 28,
          monthlyIncome: 125600,
          attendanceRate: 94,
          courseDistribution: [
            { name: '数学', value: 35 },
            { name: '语文', value: 30 },
            { name: '英语', value: 25 },
            { name: '科学', value: 10 }
          ]
        };
        commit('SET_DASHBOARD_DATA', data);
        resolve(data);
      }, 500);
    });
  },
  fetchActivities({ commit }) {
    // 模拟异步请求
    return new Promise(resolve => {
      setTimeout(() => {
        const activities = [
          { id: 1, title: '春季运动会', status: '进行中', type: '体育', startDate: '2025-03-15', endDate: '2025-03-16' },
          { id: 2, title: '科技创新展', status: '计划中', type: '科技', startDate: '2025-04-10', endDate: '2025-04-12' }
        ];
        commit('SET_ACTIVITIES', activities);
        resolve(activities);
      }, 500);
    });
  }
};

const getters = {
  dashboardData: state => state.dashboardData,
  activities: state => state.activities,
  classes: state => state.classes,
  schedules: state => state.schedules
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}; 